import { render, staticRenderFns } from "./DocImages.vue?vue&type=template&id=39445943&"
import script from "./DocImages.vue?vue&type=script&lang=js&"
export * from "./DocImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports